<script lang="ts" setup>
import {ref} from "vue";

import Dialog from "primevue/dialog";
import CatalogMenu from "@/components/CatalogMenu.vue";
import type {TItem} from "@/components/CatalogMenuItem.vue";

type TProps = {
  items: TItem[]
}

const props = defineProps<TProps>()

const isShown = ref(false)

const toggleMenu = () => {
  isShown.value = !isShown.value
}
</script>

<template>
  <div class="flex h-full" @click="toggleMenu">
    <div :class="isShown ? 'translate-x-0' : '-translate-x-0.5'" class="flex flex-col gap-[5px] size-4 transition m-auto">
      <span :class="isShown ? 'rotate-45' : ''" class="h-0.5 w-5 bg-black origin-left transition"></span>
      <span :class="isShown ? 'opacity-0' : ''" class="h-0.5 w-5 bg-black origin-left transition"></span>
      <span :class="isShown ? '-rotate-45' : ''" class="h-0.5 w-5 bg-black origin-left transition"></span>
    </div>
  </div>
  <Dialog v-model:visible="isShown" :show-header="false" block-scroll class="burger" pt:mask:class="!z-10" pt:root:class="bg-white w-full h-full px-2.5 pt-[100px] font-myriadPro" pt:transition:name="fade-dialog">
    <CatalogMenu :items="props.items" :show-on-mobile="true">
      <div class="flex flex-row text-[21px] leading-[18.9px] text-[#3064C7] gap-2.5 p-2.5 pb-5 border-b">
        <svg fill="none" height="18" viewBox="0 0 17 18" width="17" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.5 14.8235C9.3284 14.8235 10 15.5346 10 16.4118C10 17.2889 9.3284 18 8.5 18C7.6716 18 7 17.2889 7 16.4118C7 15.5346 7.6716 14.8235 8.5 14.8235ZM15.5 14.8235C16.3284 14.8235 17 15.5346 17 16.4118C17 17.2889 16.3284 18 15.5 18C14.6716 18 14 17.2889 14 16.4118C14 15.5346 14.6716 14.8235 15.5 14.8235ZM1.5 14.8235C2.32843 14.8235 3 15.5346 3 16.4118C3 17.2889 2.32843 18 1.5 18C0.67157 18 0 17.2889 0 16.4118C0 15.5346 0.67157 14.8235 1.5 14.8235ZM8.5 7.41177C9.3284 7.41177 10 8.12287 10 9C10 9.87713 9.3284 10.5882 8.5 10.5882C7.6716 10.5882 7 9.87713 7 9C7 8.12287 7.6716 7.41177 8.5 7.41177ZM15.5 7.41177C16.3284 7.41177 17 8.12287 17 9C17 9.87713 16.3284 10.5882 15.5 10.5882C14.6716 10.5882 14 9.87713 14 9C14 8.12287 14.6716 7.41177 15.5 7.41177ZM1.5 7.41177C2.32843 7.41177 3 8.12287 3 9C3 9.87713 2.32843 10.5882 1.5 10.5882C0.67157 10.5882 0 9.87713 0 9C0 8.12287 0.67157 7.41177 1.5 7.41177ZM8.5 0C9.3284 0 10 0.711074 10 1.58824C10 2.4654 9.3284 3.17647 8.5 3.17647C7.6716 3.17647 7 2.4654 7 1.58824C7 0.711074 7.6716 0 8.5 0ZM15.5 0C16.3284 0 17 0.711074 17 1.58824C17 2.4654 16.3284 3.17647 15.5 3.17647C14.6716 3.17647 14 2.4654 14 1.58824C14 0.711074 14.6716 0 15.5 0ZM1.5 0C2.32843 0 3 0.711074 3 1.58824C3 2.4654 2.32843 3.17647 1.5 3.17647C0.67157 3.17647 0 2.4654 0 1.58824C0 0.711074 0.67157 0 1.5 0Z" fill="#3064C7"/>
        </svg>
        <span class="mt-0.5">
				          Каталог
				        </span>
      </div>
    </CatalogMenu>
    <slot/>
  </Dialog>
</template>

<style lang="scss" scoped>
.burger {
  @apply bg-white;
}
</style>